// constants.ts
export const DEFAULT_HEADERS = {};
//# sourceMappingURL=constants.js.map